import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

export function getExecutionString(
  serviceReceiptItem:
    | {
        hideDuration: boolean | null | undefined;
        executionStartDate: string | null | undefined;
        executionEndDate: string | null | undefined;
        executionStartTime: string | null | undefined;
        executionEndTime: string | null | undefined;
      }
    | null
    | undefined
) {
  if (!serviceReceiptItem) {
    return '';
  }
  let executionString = '';
  if (serviceReceiptItem.executionStartDate) {
    executionString += dayjs(serviceReceiptItem.executionStartDate as string).format('DD.MM.YYYY');
    if (!serviceReceiptItem.hideDuration && serviceReceiptItem.executionStartTime) {
      executionString +=
        ' ' + dayjs(serviceReceiptItem.executionStartTime as string, 'HH:mm:ss').format('HH:mm');
    }
  }
  if (serviceReceiptItem.executionEndDate) {
    if (!serviceReceiptItem.hideDuration && serviceReceiptItem.executionEndTime) {
      if (serviceReceiptItem.executionStartDate !== serviceReceiptItem.executionEndDate) {
        executionString +=
          ' - ' +
          dayjs(serviceReceiptItem.executionEndDate as string).format('DD.MM.YYYY') +
          ' ' +
          dayjs(serviceReceiptItem.executionEndTime as string, 'HH:mm:ss').format(' HH:mm');
      } else {
        executionString +=
          ' - ' + dayjs(serviceReceiptItem.executionEndTime as string, 'HH:mm:ss').format(' HH:mm');
      }
    } else if (serviceReceiptItem.executionStartDate !== serviceReceiptItem.executionEndDate) {
      executionString +=
        ' - ' + dayjs(serviceReceiptItem.executionEndDate as string).format('DD.MM.YYYY');
    }
  }

  if (executionString === '') {
    return null;
  } else {
    return executionString;
  }
}
